import { useIberiaCardParams } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { CreditCardConfigurationType } from '@/config/types';

interface CreditCardConfigurationProps extends FormGridOptions {
  creditCardConfiguration: CreditCardConfigurationType;
}

export const CreditCardConfiguration = ({
  creditCardConfiguration,
  fieldVariant,
  fullWidth,
}: CreditCardConfigurationProps) => {
  const { getIberiaCardParams } = useIberiaCardParams();
  const { getTextIdTranslation } = useTranslation();
  const cardParams = getIberiaCardParams(creditCardConfiguration.card.type);

  const brandTypeAndProduct = `${creditCardConfiguration.card.brand}/${creditCardConfiguration.card.type}/${creditCardConfiguration.card.product}`;

  return (
    <SubSectionWrapper>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
        <TextFormField
          label="CARD_TYPE"
          name="type"
          value={cardParams ? `${getTextIdTranslation(cardParams.name)}` : creditCardConfiguration.card.type}
        />
        <TextFormField label="BRAND_TYPE_AND_PRODUCT" name="product" value={brandTypeAndProduct} />
        <TextFormField
          label="MARKETING_CAMPAIGN"
          name="marketingCampaign"
          value={creditCardConfiguration.marketingCampaign}
        />
        <TextFormField
          label="APPLICATION_ORIGIN"
          name="applicationOrigin"
          value={creditCardConfiguration.applicationOrigin}
        />
        <TextFormField label="CHANNEL" name="channel" value={creditCardConfiguration.channel} />
        <TextFormField label="CUSTOMER_TYPE" name="customerType" value={creditCardConfiguration.customerType} />
        <TextFormField label="CORPORATE_GROUP" name="corporateGroup" value={creditCardConfiguration.corporateGroup} />
        <TextFormField label="HOLDER_NAME" name="holderName" value={creditCardConfiguration.holderName} />
      </FormGridContainer>
    </SubSectionWrapper>
  );
};
